import { render } from "./DwLoader.vue?vue&type=template&id=0dab8ce9&ts=true&lang=pug"
import script from "./DwLoader.vue?vue&type=script&lang=ts"
export * from "./DwLoader.vue?vue&type=script&lang=ts"

import "./DwLoader.vue?vue&type=style&index=0&id=0dab8ce9&lang=scss"

import exportComponent from "/var/lib/gitlab-runner/builds/Ysdfp3TDT/0/z2a/z-tracker-partners/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__